import React, { useState } from 'react';
import footerBg from '../assets/images/banner.jpg';
import logoImg from '../assets/images/Logo2.PNG';
import { toast } from 'react-toastify';
import waveImg from '../assets/images/background-white-color-1.png';
import API from '../pages/Api';

const Footer = () => {
    // 1. Form state mapped perfectly with Django fields
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        remarks: '' // database key kashi match keli
    });

    const [loading, setLoading] = useState(false);

    // 2. Input values change handler
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    // 3. Form submit handler
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);


        try {
            const response = await API.post("contact-us/", {
                name: formData.name,
                email: formData.email,
                remarks: formData.remarks,
            });

            if (response.ok || response.status === 201) {
                toast.success("Thank you! Message sent successfully.");
                setFormData({ name: '', email: '', remarks: '' }); // 🟢 'message' ऐवजी 'remarks' blank kara

            } else {
                const errorData = await response.json();
                console.error("Serializer errors:", errorData);
                toast.error("Failed to send message. Please check the fields.");
            }
        } catch (error) {
            console.error("Network error:", error);
            toast.error("Server connection failed.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <footer className="relative text-white overflow-hidden">

            {/* --- WAVE IMAGE EFFECT --- */}
            <div
                className="absolute top-[-1px] left-0 w-full h-[80px] z-20 bg-no-repeat bg-top pointer-events-none"
                style={{
                    backgroundImage: `url(${waveImg})`,
                    backgroundSize: '100% 100%'
                }}
            ></div>

            {/* Background Overlay */}
            <div
                className="relative py-24 px-6 bg-cover bg-center"
                style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.85), rgba(0,0,0,0.85)), url(${footerBg})` }}
            >
                <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 pt-12">

                    {/* Left Column: Our Address */}
                    <div className="text-center flex flex-col items-center justify-center">
                        <h2 className="text-4xl font-serif mb-8 italic">Our Address</h2>
                        <div className="space-y-4 text-gray-300 italic text-lg">
                            <p>Global School of Happiness,</p>
                            <p> Pune, India</p>
                            <div className="text-white font-medium not-italic space-y-1">
                                <p>Opening Hours: Mon-Fri 11:00-00:00</p>
                                <p>Sat-Sun 15:00-00:00</p>
                            </div>
                            <p className="text-xl">
                                Call for Bookings: <span className="text-[#54a50f] font-bold">0000000000</span>
                            </p>
                        </div>
                    </div>

                    {/* Right Column: Quick Contact Form */}
                    <div className="text-center">
                        <h2 className="text-4xl font-serif mb-8 italic">Quick Contact</h2>

                        <form onSubmit={handleSubmit} className="max-w-md mx-auto space-y-4">
                            <div className="flex flex-col md:flex-row gap-4">
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Your Name"
                                    className="w-full bg-white text-black p-3 outline-none"
                                    required
                                />
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="Your Email"
                                    className="w-full bg-white text-black p-3 outline-none"
                                    required
                                />
                            </div>
                            <textarea
                                name="remarks"
                                value={formData.remarks}
                                onChange={handleChange}
                                placeholder="Message"
                                rows="4"
                                className="w-full bg-white text-black p-3 outline-none"
                                required
                            ></textarea>
                            <button
                                type="submit"
                                disabled={loading}
                                className="border-2 border-white px-10 py-2 rounded-full uppercase tracking-widest font-bold hover:bg-white hover:text-black transition-all disabled:bg-gray-500 disabled:cursor-not-allowed"
                            >
                                {loading ? 'Sending...' : 'Submit'}
                            </button>
                        </form>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="mt-24 border-t border-white/10 pt-10 flex flex-col md:flex-row justify-between items-center container mx-auto text-sm italic text-gray-400">
                    <div className="flex items-center space-x-2 mb-8 md:mb-0">
                        <img src={logoImg} alt="logo" className="w-8" />
                        <span className="text-2xl font-serif text-white">The Global School Of Happiness</span>
                    </div>

                    <div className="flex space-x-6 mb-6 md:md-0 uppercase tracking-tighter not-italic text-white">
                        <a href="/" className="text-white">Home</a>
                        <span>~</span>
                        <a href="/services" className="text-white">Our Services</a>
                        <span>~</span>
                        <a href="/products" className="text-white">Our Products</a>
                        <span>~</span>
                        <a href="/rates" className="text-white">Rates</a>
                    </div>

                    <p>© 2026 All Rights Reserved. Designed by <span className="text-yellow-500 font-bold">Geometric Infrasoft</span></p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;